import React from 'react';

var ColBodyInnerTopWr = function (_a) {
    var children = _a.children;
    return React.createElement("div", { className: 'top-inside-inner-wrapper' }, children);
};

export { ColBodyInnerTopWr };
